module.exports = __webpack_public_path__ + "img/youtube-playables-01.e942b376.png";